/**
 * Formats a number to a decimal string
 * @param {String|number} number decimal number to be formatted
 * @param {?number} decimalPlaces number of decimal places to be displayed
 * @returns {String} formatted decimal number
 */
export function formatDecimal(number, decimalPlaces) {
  const decimal = decimalPlaces || 2;
  return parseFloat(String(number)).toFixed(decimal);
}
